import React from 'react';
import {Box, Stack, Typography} from '@mui/material';

export interface FunnelStagePoint {
  stage: string;
  label: string;
  count: number;
}

interface Props {
  stages: FunnelStagePoint[];
}

const COLORS = ['#3b82f6', '#6b9ad0', '#7a9a48', '#5f7a32', '#3d5320'];

export default function PilotFunnelChart({stages}: Props) {
  const max = Math.max(...stages.map((s) => s.count), 1);
  return (
    <Stack spacing={1.25}>
      {stages.map((stage, i) => {
        const widthPct = max > 0 ? (stage.count / max) * 100 : 0;
        const conversion =
          i === 0 || stages[0].count === 0
            ? null
            : (stage.count / stages[0].count) * 100;
        return (
          <Box key={stage.stage}>
            <Stack
              direction="row"
              justifyContent="space-between"
              sx={{mb: 0.5}}
            >
              <Typography
                variant="body2"
                sx={{fontWeight: 500, color: 'text.primary'}}
              >
                {stage.label}
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{fontFamily: 'monospace'}}
              >
                {stage.count.toLocaleString()}
                {conversion !== null
                  ? ` · ${conversion.toFixed(1)}%`
                  : ''}
              </Typography>
            </Stack>
            <Box
              sx={{
                height: 10,
                borderRadius: 1,
                background: 'rgba(0,0,0,0.04)',
              }}
            >
              <Box
                sx={{
                  width: `${widthPct}%`,
                  height: '100%',
                  borderRadius: 1,
                  background: COLORS[i % COLORS.length],
                  transition: 'width 0.4s ease',
                }}
              />
            </Box>
          </Box>
        );
      })}
    </Stack>
  );
}
